<mat-dialog-content>
    <div>
        <mat-spinner style="margin:0 auto;" mode="indeterminate"></mat-spinner>
    </div>
    <br>
    <div *ngIf="config.data && config.data.message" style="white-space: pre-wrap;">{{ config.data.message }}</div>
</mat-dialog-content>
